var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useMemo, } from 'react';
import { TextInput, } from '../TextInput/index';
import { countryBasePlaceholder, countryPattern, getFormattedValue, handleChange, } from './constants';
const defaultProps = {
    phoneFormat: 'US',
    value: '',
};
const PhoneInput = (_a) => {
    var { phoneFormat: country = defaultProps.phoneFormat } = _a, textInputProps = __rest(_a, ["phoneFormat"]);
    const basePlaceholder = useMemo(() => (countryBasePlaceholder[country]
        || ''), [
        country,
    ]);
    const formattedValue = useMemo(() => (getFormattedValue({
        country,
        value: textInputProps.value || '',
    })), [
        country,
        textInputProps.value,
    ]);
    // Handles removing US phone number formatting on backspace
    const handleBackspace = useCallback((event) => {
        const target = event.target;
        if (country === 'US' && event.key === 'Backspace') {
            if (target.value.slice(-1) === ' ') {
                target.value = target.value.replace(/ - +$/, '');
            }
        }
    }, [
        country,
    ]);
    const placeholder = useMemo(() => (_jsxs("span", { children: [_jsx("span", Object.assign({ css: css `
              color: transparent;
            ` }, { children: formattedValue })), basePlaceholder
                .substring(formattedValue
                ? formattedValue.length
                : 0)] })), [
        basePlaceholder,
        formattedValue,
    ]);
    return (_jsx(TextInput, Object.assign({}, textInputProps, { mask: true, onChange: (event) => {
            handleChange(Object.assign(Object.assign({}, textInputProps), { country }), event);
        }, onKeyDown: handleBackspace, pattern: countryPattern[country] || '[0-9-.()\\s+]+', placeholder: placeholder, type: "tel", value: formattedValue })));
};
const MemoizedPhoneInput = memo(PhoneInput);
export { MemoizedPhoneInput as PhoneInput };
// MC-1068 Temporary hack for Storybook.
export default PhoneInput;
